import { styled } from '@mui/material/styles'
import { DataGrid } from '@mui/x-data-grid'

export const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  backgroundColor: '#fff',
}))

export const StyledDataGridWithMargin = styled(StyledDataGrid, {
  shouldForwardProp: prop => prop !== 'isMobile',
})<{
  isMobile?: boolean
}>`
  height: ${({ isMobile }) =>
    isMobile ? 'calc(100vh - 200px)' : 'calc(100vh - 260px)'};
  position: relative !important;
  margin-bottom: ${props => (props.isMobile ? 24 : 0)}px;
  scrollbar-gutter: stable both-edges;

  & .MuiDataGrid-main {
    position: relative !important;
  }

  & .MuiDataGrid-virtualScroller {
    position: relative !important;
    margin-top: 0 !important;
    overflow-x: auto !important;

    @media (max-width: 1000px) {
      overflow-x: scroll !important;
    }
  }

  & .MuiDataGrid-columnHeaders {
    position: sticky !important;
    top: 0;
    z-index: 1;
    background-color: #fff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
`
